import React from "react";

const BankAccount = () => {
  return <div>BankAccount</div>;
};

export default BankAccount;
